import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Avatar,
  Typography,
  message,
} from "antd";
import { CopyOutlined, PlusOutlined } from "@ant-design/icons";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import Spinner from "../components/common/Spinner/Spinner";
import jwtDecode from "jwt-decode";
import { v4 as uuidv4 } from "uuid";

const { Title } = Typography;

const columns = [
  {
    title: "#",
    key: "number",
    dataIndex: "number",
  },
  {
    title: "DATE",
    key: "date",
    dataIndex: "date",
  },
  // TODO Edited . PLEASE CHECK ND TEST ME !!!!!
  {
    title: "USER",
    key: "user",
    dataIndex: "user",
  },
  {
    title: "COMPANY",
    key: "company",
    dataIndex: "company",
  },
  {
    title: "LOCATION",
    dataIndex: "location",
    key: "location",
    // width: "25%",
  },
  {
    title: "ADDRESS",
    key: "address",
    dataIndex: "address",
  },
  // {
  //   title: "CLIENT",
  //   key: "client",
  //   dataIndex: "client",
  // },
  {
    title: "REGION",
    key: "region",
    dataIndex: "region",
  },
  {
    title: "COST CENTER",
    key: "costCenter",
    dataIndex: "costCenter",
  },
  // {
  //   title: "EMAIL",
  //   key: "email",
  //   dataIndex: "email",
  // },
  {
    title: "CONTROL TYPE",
    key: "controlType",
    dataIndex: "controlType",
  },
  {
    title: "PROBLEMS",
    key: "problems",
    dataIndex: "problems",
  },
  {
    title: "EVENT TYPE",
    key: "eventType",
    dataIndex: "eventType",
  },
  {
    title: "DESCRIPTION",
    key: "description",
    dataIndex: "description",
  },
  {
    title: "COMMENT",
    key: "comment",
    dataIndex: "comment",
  },
  {
    title: "ACTIONS",
    key: "actions",
    dataIndex: "actions",
  },
];

function Reports() {
  const history = useHistory();
  const location = useLocation();

  const [token, setToken] = useState(localStorage.getItem("token"));
  const [messageApi, contextHolder] = message.useMessage();
  const [messageApi2, contextHolder2] = message.useMessage();

  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);

  const [locations, setLocations] = useState();

  const [reports, setReports] = useState();
  const [usernames, setUsernames] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [clients, setClients] = useState([]);

  const [loadingReports, setLoadingReports] = useState(false);

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Location ID copied to clipboard",
    });
  };

  const copyToClipBoard = async (copyMe) => {
    try {
      await navigator.clipboard.writeText(copyMe);
      success();
    } catch (err) {
      // setCopySuccess('Failed to copy!');
    }
  };

  const successDeleteMessage = () => {
    // messageApi2.open({
    //   type: "success",
    //   content: "Report deleted successfully",
    // });
    message.success("Report deleted successfully!");
  };
  const errorMessage = () => {
    // messageApi2.open({
    //   type: "error",
    //   content: "Something went wrong. Please try again later.",
    // });
    message.error("Something went wrong. Please try again later.");
  };

  const deleteReport = async (reportId) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.delete(
        process.env.REACT_APP_API_URL +
          `report/deleteReport?reportId=${reportId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      successDeleteMessage();
      getReports();
    } catch (error) {
      console.log(error);
      errorMessage();
    }
  };

  function convertISOToCustomFormat(isoDate) {
    // // Create a Date object from the ISO date string
    // const date = new Date(isoDate);
    //
    // // Convert the date to Romania time zone
    // date.setUTCHours(date.getUTCHours() + 3);
    //
    // // Extract the date components
    // const year = date.getFullYear();
    // const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is zero-based
    // const day = String(date.getDate()).padStart(2, "0");
    // const hours = String(date.getHours()).padStart(2, "0");
    // const minutes = String(date.getMinutes()).padStart(2, "0");
    //
    // // Create the custom format string
    // const customFormat = `${day}/${month}/${year} ${hours}:${minutes}`;
    //
    // return customFormat;

    // Create a Date object from the ISO date string
    const date = new Date(isoDate);

    // Get the current year, month, and day
    const currentYear = date.getFullYear();
    const currentMonth = date.getMonth();
    const currentDay = date.getDate();

    // Check if the date falls within the Romanian winter time interval (usually ends in March)
    const isRomanianWinterTime =
      currentMonth === 9 ||
      currentMonth === 10 ||
      currentMonth === 11 ||
      currentMonth === 0 ||
      currentMonth === 1 ||
      currentMonth === 2;

    // Adjust the time zone offset based on the interval
    if (isRomanianWinterTime) {
      date.setUTCHours(date.getUTCHours() + 2);
    } else {
      date.setUTCHours(date.getUTCHours() + 3);
    }

    // Extract the date components
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is zero-based
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    // Create the custom format string
    const customFormat = `${day}/${month}/${year} ${hours}:${minutes}`;

    return customFormat;
  }

  const data = reports?.map((report, index) => {
    return {
      key: report.report.id,
      number: (
        <>
          <div className="ant-employed">
            <span>{index + 1}</span>
          </div>
        </>
      ),
      date: (
        <>
          <div className="ant-employed">
            <span>
              {report?.report.createdAt
                ? convertISOToCustomFormat(report?.report.createdAt)
                : ""}
            </span>
          </div>
        </>
      ),
      // TODO Get user in different ways
      // user: (
      //   <>
      //     <Avatar.Group>
      //       <div
      //         className="avatar-info"
      //         // style={{ cursor: "pointer" }}
      //         // onClick={() => copyToClipBoard(location.id)}
      //       >
      //         <Title level={5}>
      //           {/*{report.userId ? getUser(report.userId) : null}*/}
      //           {usernames[index]}
      //           {/*<CopyOutlined style={{ color: "#1ec8ff" }} />*/}
      //         </Title>
      //         {/*<p>{location.locationCoordinates} </p>*/}
      //       </div>
      //     </Avatar.Group>{" "}
      //   </>
      // ),
      user: (
        <>
          <Avatar.Group>
            <div className="avatar-info">
              <Title level={5}>{report.username}</Title>
            </div>
          </Avatar.Group>{" "}
        </>
      ),
      company: (
        <>
          <div className="ant-employed">
            <span>
              {report.report.societateDePaza
                ? report.report.societateDePaza
                : "N/A"}
            </span>
          </div>
        </>
      ),
      location: (
        <>
          <div className="ant-employed">
            <span>
              {report.report.obiectiv ? report.report.obiectiv : "N/A"}
            </span>
          </div>
        </>
      ),
      address: (
        <>
          <div className="ant-employed">
            <span>{report.report.adresa ? report.report.adresa : "N/A"}</span>
          </div>
        </>
      ),
      region: (
        <>
          <div className="ant-employed">
            <span>{report.report.regiune ? report.report.regiune : "N/A"}</span>
          </div>
        </>
      ),
      costCenter: (
        <>
          <div className="ant-employed">
            <span>
              {report.report.centruDeCost ? report.report.centruDeCost : "N/A"}
            </span>
          </div>
        </>
      ),

      controlType: (
        <>
          <div className="ant-employed">
            <span>
              {report.report.tipulDeControl
                ? report.report.tipulDeControl
                : "N/A"}
            </span>
          </div>
        </>
      ),
      problems: (
        <>
          <div className="ant-employed">
            <span>
              {report.report.neconformitati &&
              report.report.neconformitati === true
                ? "TRUE"
                : !report.report.neconformitati
                ? "FALSE"
                : "N/A"}
            </span>
          </div>
        </>
      ),
      eventType: (
        <>
          <div className="ant-employed">
            <span>
              {report.report.tipulEvenimentului === "null"
                ? "N/A"
                : report.report.tipulEvenimentului}
            </span>
          </div>
        </>
      ),
      description: (
        <>
          <div className="ant-employed">
            <span>
              {report.report.descriereaEvenimentului
                ? report.report.descriereaEvenimentului
                : "N/A"}
            </span>
          </div>
        </>
      ),
      comment: (
        <>
          <div className="ant-employed">
            <span>
              {report.report.observatii ? report.report.observatii : "N/A"}
            </span>
          </div>
        </>
      ),
      actions: (
        <>
          <div className="ant-employed">
            <Button
              onClick={() => deleteReport(report?.report.id)}
              type="danger"
            >
              Delete
            </Button>
          </div>
        </>
      ),
      // client: (
      //   <>
      //     <div className="ant-employed">
      //       <span>{clients[index] ? clients[index] : "N/A"}</span>
      //     </div>
      //   </>
      // ),
    };
  });

  const getLocations = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "location/getAllLocations",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      setLocations(response.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const addReport = async () => {
    console.log("onFinish called");
    const token = localStorage.getItem("token");

    const data = {
      id: uuidv4(),
      centruDeCost: "RO432554",
      regiune: "Galati",
      obiectiv: "Mega Image Mosilor",
      adresa: "Str. Mosilor 33",
      societateDePaza: "SSG Security",
      tipulDeControl: "Control de zi",
      neconformitati: true,
      userId: "642032646dcddd9d539aca2d",
      tipulEvenimentului: "furt",
      descriereaEvenimentului: "Descriere eveniment",
      observatii: "observatiile utilizatorului",
    };

    try {
      console.log("TRUE");
      const response = await axios.post(
        process.env.REACT_APP_API_URL +
          `report/createReport?id=${data.id}&centruDeCost=${data.centruDeCost}&regiune=${data.regiune}&obiectiv=${data.obiectiv}&adresa=${data.adresa}&societateDePaza=${data.societateDePaza}&tipulDeControl=${data.tipulDeControl}&neconformitati=${data.neconformitati}&userId=${data.userId}&tipulEvenimentului=${data.tipulEvenimentului}&descriereaEvenimentului=${data.descriereaEvenimentului}&observatii=${data.observatii}`,

        {},

        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      success();
    } catch (e) {
      console.log(e);
      // error();
    }
  };

  const getUser = async (id) => {
    const token = localStorage.getItem("token");
    try {
      setLoadingData(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + `user/getUser?userId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      // console.log(response.data.username);
      // console.log(response.data.societateDePaza);
      // console.log(response.data.clients);
      setUsernames((prevVals) => [...prevVals, response.data.username]);
      setCompanies((prevVals) => [...prevVals, response.data.societateDePaza]);
      setClients((prevVals) => [...prevVals, response.data.clients]);

      // setUsername(response.data.username);
      // setPassword(response.data.password);
      // setConfirmPassword(response.data.password);
      // setCompany(response.data.company);
      // setClients(response.data.clients);
      // setSelectedLocations(response.data.locationList);
      // setEmail(response.data.email);
      // setPhoneNumber(response.data.phoneNumber);
      // setDescription(response.data.description);
      // setRole(response.data.roles);
      // setNeedsNFC(response.data.needsNFC);

      setLoadingData(false);

      // return {
      //   username: response.data.username,
      //   company: response.data.societateDePaza,
      // };
    } catch (error) {
      console.log(error);
    }
  };

  const getReports = async () => {
    setLoadingReports(true);
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "report/getAllReports2",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      // console.log(response);
      setReports(response.data);

      setUsernames([]);
      setCompanies([]);

      // TODO Get user in different ways
      // const users = response.data.map((report) => {
      //   getUser(report.userId);
      // });

      // console.log("USERS:", users);

      setLoading(false);
      setLoadingReports(false);
    } catch (error) {
      console.log(error);
    }
    setLoadingReports(false);
  };

  const exportReports = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL +
          "csvExport/exportReportsToCSV?separator=%2C",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "text/csv",
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], { type: "text/csv" });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", "reports.csv");

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    let currentDate = new Date();
    setToken(localStorage.getItem("token"));
    console.log("app token", token);
    if (
      (token && jwtDecode(token).exp * 1000 < currentDate.getTime()) ||
      token === null
    ) {
      history.push("/sign-in");
    } else {
      history.push(location.pathname);
    }
  }, [token]);

  useEffect(() => {
    getReports();
  }, []);

  return (
    <>
      {contextHolder}
      {contextHolder2}
      <div className="tabled">
        {/*<button onClick={() => getReports()}>get reports</button>*/}
        {/*<button onClick={() => console.log(usernames)}>log users</button>*/}
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Reports"
              extra={
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    onClick={() => exportReports()}
                    style={{ marginBottom: "10px", marginTop: "10px" }}
                    type="secondary"
                    className="tag-secondary"
                  >
                    Export Reports
                  </Button>
                  {/*<NavLink to="/add-location">*/}
                  {/*  <Button type="secondary" className="tag-primary">*/}
                  {/*    <PlusOutlined />*/}
                  {/*    Add Location*/}
                  {/*  </Button>*/}
                  {/*</NavLink>*/}
                  {/*TODO Search box*/}
                  {/*<Input*/}
                  {/*  style={{ marginLeft: "20px" }}*/}
                  {/*  className="header-search"*/}
                  {/*  placeholder="Type here..."*/}
                  {/*  prefix={<SearchOutlined />}*/}
                  {/*/>*/}
                  {/*TODO Radio Button*/}
                  {/*<Radio.Group style={{display: "flex", flexDirection: "row"}} onChange={onChange} defaultValue="a">*/}
                  {/*  <Radio.Button value="a">All</Radio.Button>*/}
                  {/*  <Radio.Button value="b">ONLINE</Radio.Button>*/}
                  {/*</Radio.Group>*/}
                </div>
              }
            >
              <div className="table-responsive">
                {loading || loadingReports ? (
                  <Spinner />
                ) : (
                  <Table
                    style={{ padding: "10px" }}
                    columns={columns}
                    dataSource={data}
                    pagination={true}
                    className="ant-border-space"
                  />
                )}
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Reports;
